import { useEffect } from 'react';

export const useCustomKeyPress = ({ key = 'Enter', callback, active = true }) => {
  useEffect(() => {
    if (!active || !callback) return;

    const handleKeyDown = (e) => {
      if (e.key !== key) return;

      const tag = e.target?.tagName?.toLowerCase();

      // Ignore typing in form fields or editable areas
      if (['textarea', 'input', 'select', 'button'].includes(tag)) return;
      if (e.target?.isContentEditable) return;

      // Find all open modals and pick the last (top-most)
      const modals = Array.from(document.querySelectorAll('.modal.show'));
      const topModal = modals[modals.length - 1];

      // Only fire if: (1) there is a modal open, and (2) the event is inside the top-most modal
      if (!topModal) return;
      if (!topModal.contains(e.target)) return;

      callback(e);
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [key, callback, active]);
};
